import {
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import { withStyles } from "@material-ui/core/styles";
import AddIcon from "@material-ui/icons/Add";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import React, { Component } from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import InputFormat from "../../../partials/inputForm";
import PriceFormat from "../../../partials/priceFormat";
import { getNumberOnString } from "../../../partials/validateNumber";
import NumberFormatCustom from "../../numberFormat";
import { style } from "./styles";

class Variant extends Component {
  constructor(props) {
    super(props);
    this.state = {
      product: this.props.product || {},
      addNewVariant: false,
      editIndex: -1,
      editVariant: {},
    };
  }
  async componentDidMount() {}
  componentWillReceiveProps = (nextProps) => {
    if (nextProps.product && nextProps.product.id !== this.state.product.id)
      this.setState({
        product: nextProps.product,
      });
  };
  newRecord = () => {
    this.setState({
      addNewVariant: true,
      newSku: "",
      newPrice: 0,
      newWeight: 0,
      newStock_quantity: 0,
    });
  };
  handleChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    let state = this.state;
    if (name === "newPrice" || name === "newStock_quantity")
      state[name] = getNumberOnString(value);
    else state[name] = value;
    this.setState(state);
  };
  handleAddNewVariant = () => {
    let {
      product,
      newStock_quantity,
      newPrice,
      newSku,
      newWeight,
    } = this.state;
    let variants = product.variants || [];
    variants.push({
      sku: newSku,
      price: newPrice,
      stock_quantity: newStock_quantity,
      weight: newWeight,
    });
    this.setState({
      product: product,
      newStock_quantity: 1,
      newPrice: 0,
      newWeight: 0,
      newSku: "",
      addNewVariant: false,
    });
  };
  handleDeleteVariant = (index) => {
    let { product } = this.state;
    let variants = product.variants || [];
    variants.splice(index, 1);
    this.setState({
      ...product,
      newStock_quantity: 1,
      newPrice: 0,
      newWeight: 0,
      newSku: "",
      addNewVariant: false,
    });
  };
  handleEditVariant = (index, variants) => {
    this.setState({
      editIndex: index,
      editVariant: variants,
      backupEdit: { ...variants },
    });
  };
  handleUpdateVariant = (index) => {
    let { product, editVariant } = this.state;
    let variants = product.variants || [];
    variants[index] = editVariant;
    this.setState({ editIndex: -1, editVariant: {}, product: product });
  };
  changeEdit = (property, value) => {
    let { editVariant } = this.state;
    editVariant[property] = value;
    this.setState({ editVariant });
  };
  handleDiscardVariant = (index) => {
    let { product, backupEdit } = this.state;
    let variants = product.variants || [];
    variants[index] = backupEdit;
    this.setState({ editIndex: -1, editVariant: {}, product: product });
  };
  render() {
    const { classes, t } = this.props;
    let {
      addNewVariant,
      newSku,
      newPrice,
      newStock_quantity,
      newWeight,
      product,
    } = this.state;
    let variants = product.variants || [];
    return (
      <Paper className={classes.container}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>{t("product_sku")}</TableCell>
              <TableCell align="left">
                {t("product_variant_price")}&nbsp;({this.props.currencyCode})
              </TableCell>
              <TableCell align="left">{t("product_variant_stock")}</TableCell>
              <TableCell align="left">
                {t("product_variant_weight")}&nbsp;(kg)
              </TableCell>
              <TableCell align="left"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {variants.map((row, index) => {
              if (index === this.state.editIndex) {
                return (
                  <TableRow>
                    <TableCell align="left" component="th" scope="row">
                      <InputFormat
                        variant="standard"
                        // label="New tag name"
                        name="newSku"
                        value={row.sku}
                        onChange={(e) => this.changeEdit("sku", e.target.value)}
                      />
                    </TableCell>
                    <TableCell align="left" component="th" scope="row">
                      <InputFormat
                        variant="standard"
                        // label="New tag name"
                        name="newPrice"
                        value={row.price}
                        onChange={(e) =>
                          this.changeEdit("price", e.target.value)
                        }
                        InputProps={{
                          inputComponent: NumberFormatCustom,
                        }}
                      />
                    </TableCell>
                    <TableCell align="left" component="th" scope="row">
                      <InputFormat
                        variant="standard"
                        // label="New tag name"
                        name="newStock_quantity"
                        value={row.stock_quantity}
                        onChange={(e) =>
                          this.changeEdit("stock_quantity", e.target.value)
                        }
                      />
                    </TableCell>
                    <TableCell align="left" component="th" scope="row">
                      <InputFormat
                        variant="standard"
                        // label="New tag name"
                        name="newWeight"
                        value={row.weight}
                        onChange={(e) =>
                          this.changeEdit("weight", e.target.value)
                        }
                      />
                    </TableCell>
                    <TableCell align="left">
                      <IconButton
                        aria-label="edit"
                        onClick={() => this.handleUpdateVariant(index)}
                      >
                        <CheckIcon />
                      </IconButton>
                      <IconButton
                        aria-label="edit"
                        onClick={() => this.handleDiscardVariant(index)}
                      >
                        <CloseIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                );
              }
              return (
                <TableRow key={row.id}>
                  <TableCell component="th" scope="row" align="left">
                    {row.sku}
                  </TableCell>
                  <TableCell align="left">
                    <PriceFormat
                      // thousandSeparator={true}
                      // displayType={"text"}
                      value={row.price}
                    />
                  </TableCell>
                  <TableCell align="left">{row.stock_quantity}</TableCell>
                  <TableCell align="left">{row.weight}</TableCell>
                  <TableCell align="left">
                    <IconButton
                      aria-label="edit"
                      onClick={() => this.handleDeleteVariant(index)}
                    >
                      <DeleteIcon />
                    </IconButton>
                    <IconButton
                      aria-label="edit"
                      onClick={() => this.handleEditVariant(index, row)}
                    >
                      <EditIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              );
            })}
            {addNewVariant && (
              <TableRow>
                <TableCell align="left" component="th" scope="row">
                  <InputFormat
                    variant="standard"
                    // label="New tag name"
                    name="newSku"
                    value={newSku}
                    onChange={this.handleChange}
                  />
                </TableCell>
                <TableCell align="left" component="th" scope="row">
                  <InputFormat
                    variant="standard"
                    // label="New tag name"
                    name="newPrice"
                    value={newPrice}
                    onChange={this.handleChange}
                    InputProps={{
                      inputComponent: NumberFormatCustom,
                    }}
                  />
                </TableCell>
                <TableCell align="left" component="th" scope="row">
                  <InputFormat
                    variant="standard"
                    // label="New tag name"
                    name="newStock_quantity"
                    value={newStock_quantity}
                    onChange={this.handleChange}
                  />
                </TableCell>
                <TableCell align="left" component="th" scope="row">
                  <InputFormat
                    variant="standard"
                    // label="New tag name"
                    name="newWeight"
                    value={newWeight}
                    onChange={this.handleChange}
                  />
                </TableCell>
                <TableCell align="left">
                  <IconButton
                    aria-label="edit"
                    onClick={() => this.handleAddNewVariant()}
                  >
                    <AddIcon />
                    {/* <DeleteIcon /> */}
                  </IconButton>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <div className={classes.buttonContainer}>
          <Button
            className={classes.button}
            variant="contained"
            onClick={() => this.newRecord()}
            color="primary"
          >
            {t("product_add_new_variant")}
          </Button>
          {/* <Button  variant="contained"  color="primary">ADD NEW OPTIONS</Button> */}
        </div>
      </Paper>
    );
  }
}
const mapState = (state) => ({
  currencyCode: state.setting.setting.currencyCode,
});

const mapDispatch = (dispatch) => ({});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(style, { withTheme: 0 })(Variant)));
